import React, { useCallback } from "react";
import {
  getOrderValues,
  getProductValues
} from "../../helpers/getInvoiceValues";

export default function InvoiceWmo({ orderDetails, pageType, unfoldedShippingConfig = null }) {
  const {
    shippingInfo,
    billingInfo,
    shippingMethod,
    merchantId,
    date,
    total,
    paymentMethod,
    subtotal,
    totalShipping,
    totalHandling,
    totalTax,
    items,
    shippingProtectionAmount,
    totalWarranty,
    totalProductProtection,
    totalCorePrice,
    isDynamicShipping = 'a',
  } = getOrderValues(orderDetails, pageType);
  const unfoldedShipping = unfoldedShippingConfig

  const findVariation = unfoldedShipping?.label?.variations?.find(variation => variation.variationValue === isDynamicShipping?.toLowerCase())
  const getShippingMethodLabel = useCallback(
    (shippingMethod) => {
      switch (shippingMethod?.toLowerCase()) {
        case 'ground':
          return findVariation?.foldedLabel || 'Standard'
        case 'ground_unfolded':
          return findVariation?.unfoldedLabel || 'Truck Freight'
        default:
          return shippingMethod
      }
    },
    [findVariation]
  )

  return (
    <div id="invoice" style={{ display: "none" }}>
      <style>{`@media print { * {-webkit-print-color-adjust: exact;}`}</style>
      <table
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        style={{ padding: "24px" }}
      >
        <tbody>
          <tr>
            <td vlign="top">
              <table cellPadding="0" cellSpacing="0" width="100%">
                <tbody>
                  <tr>
                    <td width="50%" style={{ paddingBottom: 8 }}>
                      <svg viewBox="0 0 1020 60" color="plain" size={35}>
                        <path
                          fill="#034999"
                          d="M8.0221014,41.3535957c-1.5497427-1.5497398-2.4030838-3.6101418-2.4030838-5.8016396  c0-2.1915016,0.8533411-4.2519016,2.4030838-5.8016434c1.5497427-1.5494747,3.6101446-2.4030838,5.8016424-2.4030838h20.5116825  c1.721756,0,3.340683-0.67029,4.558239-1.8878498c1.2175636-1.2178288,1.8881226-2.8367538,1.8881226-4.5585098  c0-1.7220268-0.6705589-3.3409519-1.8881226-4.5585117c-1.217556-1.2175579-2.836483-1.8881168-4.558239-1.8881168H23.0172157  l-1.8679276,4.9816818h13.1861382c0.8078499,0,1.4649467,0.6570988,1.4649467,1.4649467s-0.6570969,1.4649448-1.4649467,1.4649448  H13.8237438c-1.7774801,0-3.5051594,0.3496819-5.1343136,1.0388165c-1.5710092,0.6643677-2.9805021,1.6143494-4.1897163,2.8235645  c-1.2092137,1.2089443-2.1589258,2.6184368-2.8235626,4.1894455c-0.6891339,1.629425-1.0385457,3.3568344-1.0385457,5.1343155  c0,1.7774773,0.3494118,3.5048904,1.0385457,5.1343117c0.664637,1.5710106,1.614349,2.9805031,2.8235626,4.1897163  c1.2092142,1.2089462,2.6187072,2.1589279,4.1897163,2.8232956c1.6291542,0.6891327,3.3568335,1.0388145,5.1343136,1.0388145  h8.79076l1.8679276-4.981411H13.8237438C11.632246,43.7566833,9.5718441,42.9030724,8.0221014,41.3535957"
                        />
                        <path
                          fill="#034999"
                          d="M46.4826431,15.7664738c-0.6643677-1.5710087-1.6143532-2.9805002-2.8232956-4.1894445  c-1.2092171-1.2092152-2.6187057-2.1591978-4.1897163-2.8235626c-1.629425-0.6891365-3.3568344-1.0385461-5.1343117-1.0385461  h-8.79076L23.67663,12.696063h10.6586895c2.191494,0,4.2518997,0.8536119,5.8016396,2.4030848  c1.5494766,1.5497437,2.4030838,3.6101437,2.4030838,5.8016415s-0.8536072,4.2518997-2.4030838,5.8016415  c-1.5497398,1.5494747-3.6101456,2.4030838-5.8016396,2.4030838H13.8236361c-1.7217579,0-3.3406811,0.6705589-4.5582428,1.8881187  c-1.2175579,1.2175598-1.8881164,2.836483-1.8881164,4.5585098c0,1.7217598,0.6705585,3.340683,1.8881164,4.5582428  c1.2175617,1.2175598,2.8364849,1.8881149,4.5582428,1.8881149h11.3182096l1.8679295-4.981411H13.8236361  c-0.807847,0-1.4652166-0.6573677-1.4652166-1.4649467c0-0.8081169,0.6573696-1.4652176,1.4652166-1.4652176h20.5116844  c1.7774773,0,3.5048866-0.349411,5.1343117-1.0388145c1.5710106-0.6643677,2.9804993-1.6143475,4.1897163-2.8232937  c1.2089424-1.2092133,2.1589279-2.6187057,2.8232956-4.1897144c0.6893997-1.629425,1.0385399-3.3568344,1.0385399-5.1343136  C47.521183,19.1233082,47.1720428,17.3958988,46.4826431,15.7664738"
                        />
                        <path
                          fill="#034999"
                          d="M116.6034012,22.6964912h-4.9361877c-5.2759094,0-9.8586502,3.6338329-11.0990906,8.7153854  l-2.2991714,11.7960281h6.7039719l1.9443817-10.008049c0.4409332-2.2692947,2.4386215-3.9162159,4.7499084-3.9162159h3.6774368  L116.6034012,22.6964912z"
                        />
                        <path
                          fill="#034999"
                          d="M56.9039841,32.5545998c1.2197113-6.1806641,6.5871429-10.1655254,12.8897552-10.1655254  c5.7332687,0,9.3522949,3.4970837,8.7016602,8.3358231H71.66436c-0.0409241-1.545166-1.2606354-2.6432037-3.3751373-2.6432037  c-1.9922943,0-4.0661545,1.5045185-4.6355019,4.4729061c-0.5693398,3.0903358,0.9760933,5.2861404,3.4970818,5.2861404  c1.8297043,0,3.090065-1.1386871,3.700325-2.6838531h6.9936295c-1.0571213,4.9200363-6.4245605,8.3764725-11.3852386,8.3764725  C59.7501602,43.5333595,55.6839981,38.7349968,56.9039841,32.5545998"
                        />
                        <path
                          fill="#034999"
                          d="M84.6005096,43.5332794c-0.005661,0-0.0107727-0.0002708-0.0161591-0.0002708  c-0.0051117,0-0.010231,0.0002708-0.0153427,0.0002708H84.6005096z"
                        />
                        <path
                          fill="#034999"
                          d="M90.0989456,22.389183c-4.2680435,0-7.8073959,2.0595932-9.4260483,4.8500462l5.235527,2.4063148  c0.4899368-1.2751675,2.0111465-2.670126,3.7145996-2.670126c1.9126053,0,2.6601562,1.0479698,2.3379364,2.45854  c-0.2016296,0.8062325-0.8062439,1.2897015-1.7330704,1.2897015l-3.7256241,0.0010757  c-3.5533447,0-7.0240479,1.6525764-7.8090134,5.7432289c-0.7427063,3.7546997,1.9758682,7.055542,5.8097153,7.0649643  c2.6348572-0.0048447,4.5404739-1.1822929,5.392746-2.8865547l-0.4880524,2.5616379h6.6687164l2.4800644-12.7678127  C99.4512405,25.8046989,95.7509155,22.389183,90.0989456,22.389183 M90.9121857,35.6243134  c-0.3251877,1.791748-1.9917603,3.2327385-3.617691,3.2327385c-1.6259155,0-2.3982391-0.934639-2.1543427-2.1032028  c0.2438889-1.1685677,1.2600861-1.5968513,2.4388809-1.5968513h3.414444L90.9121857,35.6243134z"
                        />
                        <path
                          fill="#034999"
                          d="M130.9223022,22.3891563c-2.5209961,0-4.4319916,0.772583-5.855217,2.0738621l0.3321915-1.7664452  h-6.7125931l-5.0758972,26.041441h6.7139359l1.3268509-6.7497406c0.935173,0.9351768,3.0496902,1.544899,5.3671646,1.544899  c5.6928864,0,9.9622803-4.0255089,11.1413422-10.1652565C139.3798065,27.1466007,135.9645538,22.3891563,130.9223022,22.3891563   M131.5323029,32.7985725c-0.4877777,2.8464432-2.6022949,5.0013313-5.0419922,5.0826263  c-2.4803391,0.0815659-3.9442139-1.9516449-3.4561615-4.7574425c0.4877777-2.8461742,2.6429367-5.0013313,5.0826263-5.0826283  C130.5564728,27.9598312,132.02034,29.9930439,131.5323029,32.7985725"
                        />
                        <path
                          fill="#034999"
                          d="M176.5918579,22.6964912h-4.9364624c-5.2759094,0-9.8586426,3.6338329-11.0988312,8.7153854  l-2.2991638,11.7960281h6.7037048l1.9443817-10.008049c0.4409332-2.2692947,2.4386139-3.9162159,4.7499084-3.9162159h3.6774445  L176.5918579,22.6964912z"
                        />
                        <path
                          fill="#034999"
                          d="M144.5253143,43.5332794c-0.005661,0-0.0107727-0.0002708-0.0164185-0.0002708  c-0.0048523,0-0.009964,0.0002708-0.0150757,0.0002708H144.5253143z"
                        />
                        <path
                          fill="#034999"
                          d="M150.1051331,22.389183c-4.2683105,0-7.8076477,2.0595932-9.4260406,4.8500462l5.23526,2.4063148  c0.4899292-1.2751675,2.0114136-2.670126,3.7148743-2.670126c1.9125977,0,2.660141,1.0479698,2.3379364,2.45854  c-0.2019043,0.8062325-0.8065186,1.2897015-1.7333374,1.2897015l-3.7253571,0.0010757  c-3.55336,0-7.0240631,1.6525764-7.8092957,5.7432289c-0.7424316,3.7546997,1.9758911,7.055542,5.8097229,7.0649643  c2.6351166-0.0048447,4.540741-1.1822929,5.3930206-2.8865547l-0.4880676,2.5616379h6.6687164l2.4798126-12.7678127  C159.4571686,25.8046989,155.7571259,22.389183,150.1051331,22.389183 M150.9183807,35.6243134  c-0.3251801,1.791748-1.9917603,3.2327385-3.617691,3.2327385c-1.6259155,0-2.3985138-0.934639-2.1543427-2.1032028  c0.2438965-1.1685677,1.2598267-1.5968513,2.4386139-1.5968513h3.4147034L150.9183807,35.6243134z"
                        />
                        <path
                          fill="#034999"
                          d="M189.1973724,36.1734657h5.6519623c-0.1219482,1.4638748,1.2606201,2.4396973,3.0090332,2.4396973  c1.5045319,0,2.6835785-0.6506386,2.6835785-1.6671104c0-2.8055267-9.5555267,0.16259-9.5555267-7.4003811  c0-4.0661564,4.6761475-7.1564884,9.1487885-7.1564884c4.9200439,0,8.2138672,2.8461742,7.7258301,6.8716831h-5.6926117  c0.0406494-1.3823051-1.2606506-2.3581295-2.643219-2.3581295c-1.4229431,0-2.4394226,0.6506405-2.4394226,1.8297062  c0,2.8870907,9.8398132-0.4473991,9.8398132,7.0751934c0,4.5945816-4.1065369,7.725563-9.6365662,7.725563  C192.1654816,43.5331993,188.6686707,40.3209229,189.1973724,36.1734657"
                        />
                        <path
                          fill="#034999"
                          d="M184.3185272,28.2445011h5.1641846l1.0603638-5.5480633h-5.1639404l1.0802765-5.5171051h-6.7090912  l-3.6047516,18.5874901c-0.9354401,4.6355019,1.8703461,7.4410286,6.46492,7.4410286h3.9444885l1.0977783-5.5300293h-2.927475  c-1.3013,0-2.0738678-0.8132286-1.7893372-2.2361832L184.3185272,28.2445011z"
                        />
                        <polygon
                          fill="#F47920"
                          points="212.1223907,39.6412888 211.4289398,43.2072868 207.6895905,43.2072868 208.3830261,39.6412888 "
                        />
                        <path
                          fill="#F47920"
                          d="M213.9539337,35.9384613c0.8323517-4.215559,4.4933624-6.9338665,8.7923737-6.9338665  c3.9105682,0,6.3787842,2.3853168,5.9354401,5.6858883h-4.659729c-0.0277405-1.0541573-0.8598022-1.802784-2.3018799-1.802784  c-1.3588867,0-2.7734833,1.026165-3.1619415,3.0507622c-0.388443,2.1080513,0.6657257,3.6058388,2.3853302,3.6058388  c1.2479706,0,2.1077728-0.7766228,2.523941-1.83078h4.7703705c-0.7211609,3.3562965-4.3821869,5.7136154-7.7656708,5.7136154  C215.8956146,43.4271355,213.1221313,40.1542892,213.9539337,35.9384613"
                        />
                        <path
                          fill="#F47920"
                          d="M229.9013062,37.436142c-0.1943665-4.7980881,3.6052856-8.431385,8.458847-8.431385  c3.8001862,0,6.57341,2.6348591,6.6845856,5.9908867c0.1940918,4.7983589-3.6055603,8.431385-8.4593811,8.431385  C232.7854462,43.4270287,230.0122223,40.7924385,229.9013062,37.436142 M240.4404755,35.5501785  c0-1.6364212-0.9707184-2.6625824-2.4959564-2.6625824c-2.135788,0-3.4394684,1.9694138-3.4394684,3.9940109  c0,1.6364212,0.9709625,2.6625862,2.4964905,2.6625862C239.1370392,39.5441933,240.4404755,37.5747757,240.4404755,35.5501785"
                        />
                        <path
                          fill="#F47920"
                          d="M248.3438263,29.2283478h4.5762787l-0.3324738,1.6641502  c1.0539093-1.1093426,2.4685211-1.8859653,4.2433014-1.8859653c2.1357727,0,3.2171021,0.832077,3.6612854,2.3575916  c0.9984436-1.2205219,2.9121399-2.3575916,4.9370117-2.3575916c3.3280029,0,4.8812561,2.3298645,4.2709961,5.4640751  l-1.691864,8.7366524h-4.5762939l1.5255127-7.8213959c0.3052673-1.5532417-0.3607178-2.5516777-1.6641541-2.5516777  c-1.3036804,0-2.3575745,0.998436-2.6622925,2.5516777l-1.5255127,7.8213959h-4.5765533l1.5254974-7.8213959  c0.304718-1.5532417-0.3607178-2.5516777-1.6641388-2.5516777c-1.3037109,0-2.3578644,0.998436-2.6628571,2.5516777  l-1.5255127,7.8213959h-4.5762787L248.3438263,29.2283478z"
                        />
                        <g>
                          <path
                            fill="#034999"
                            d="M90.2728729-346.7549744h-8.6342163c-9.2284317,0-17.2444077,6.3562012-19.4141426,15.2446594   l-4.0216331,20.6332092H69.929245l3.4010315-17.5057373c0.7712784-3.9693604,4.2655563-6.8500977,8.3083801-6.8500977h6.4324493   L90.2728729-346.7549744z"
                          />
                          <path
                            fill="#034999"
                            d="M-14.1512794-329.5115051c2.1334743-10.8110046,11.5220032-17.781189,22.5463066-17.781189   c10.0284357,0,16.3587151,6.1170044,15.220643,14.5807495H11.6670561   c-0.0715752-2.7027588-2.2050571-4.6234131-5.9036741-4.6234131c-3.4848549,0-7.1123786,2.6316528-8.1082554,7.8238525   c-0.9958699,5.4055176,1.7073514,9.2463379,6.1169758,9.2463379c3.2004521,0,5.4050341-1.9917603,6.4724789-4.6944885h12.233017   c-1.8490772,8.605957-11.2376213,14.651825-19.914669,14.651825   C-9.1728497-310.3078308-16.2852345-318.7009583-14.1512794-329.5115051"
                          />
                          <path
                            fill="#034999"
                            d="M34.2945175-310.3079834c-0.009903,0-0.0188408-0.0004578-0.0282669-0.0004578   c-0.0089378,0-0.0178909,0.0004578-0.0268288,0.0004578H34.2945175z"
                          />
                          <path
                            fill="#034999"
                            d="M43.9121971-347.2924805c-7.465519,0-13.6564255,3.6025696-16.4877243,8.4835205l9.1578102,4.2090454   c0.8569756-2.2304688,3.5178185-4.6705017,6.4974403-4.6705017c3.3454704,0,4.6530609,1.8330688,4.0894394,4.3003845   c-0.352684,1.4102478-1.410244,2.2559204-3.0314217,2.2559204l-6.5167389,0.0018921   c-6.2153778,0-12.286211,2.890625-13.6592541,10.0458374c-1.2991123,6.5675964,3.4561291,12.3413086,10.1621571,12.3577881   c4.6088028-0.0084534,7.9420433-2.0680237,9.4328003-5.0490417l-0.8536797,4.4807129h11.6646843l4.3380508-22.3330078   C60.2709084-341.3181763,53.7984314-347.2924805,43.9121971-347.2924805 M45.3346863-324.1420593   c-0.5688057,3.1340637-3.4839211,5.6546021-6.3279381,5.6546021c-2.843998,0-4.194912-1.6348572-3.7683067-3.6788635   c0.4266014-2.0440063,2.2041054-2.7931519,4.2660141-2.7931519h5.9724159L45.3346863-324.1420593z"
                          />
                          <path
                            fill="#034999"
                            d="M115.3189926-347.2925415c-4.4096222,0-7.7522812,1.3513794-10.2417374,3.627533l0.5810471-3.0898132   H93.9168701l-8.8785782,45.5507812h11.7437897l2.3208771-11.8063965c1.6357727,1.6357727,5.334404,2.7022705,9.3880539,2.7022705   c9.9578018,0,17.4256821-7.0412598,19.48806-17.7807007C130.1125488-338.9709778,124.1387177-347.2925415,115.3189926-347.2925415    M116.3859787-329.0847473c-0.8532104,4.9789124-4.5518417,8.7481689-8.8192673,8.8903503   c-4.3385239,0.1426697-6.8990784-3.4137573-6.0453949-8.3215637c0.8531876-4.9784241,4.6229248-8.7481384,8.8903427-8.8903503   C114.6791-337.5485229,117.2396469-333.9920959,116.3859787-329.0847473"
                          />
                          <path
                            fill="#034999"
                            d="M195.2025909-346.7549744h-8.6346741c-9.2284393,0-17.2444,6.3562012-19.4136963,15.2446594   l-4.0216217,20.6332092h11.7258759l3.4010468-17.5057373c0.771286-3.9693604,4.265564-6.8500977,8.3083954-6.8500977h6.4324493   L195.2025909-346.7549744z"
                          />
                          <path
                            fill="#034999"
                            d="M139.112915-310.3079834c-0.0099182,0-0.0188446-0.0004578-0.0287323-0.0004578   c-0.0084839,0-0.0174255,0.0004578-0.0263519,0.0004578H139.112915z"
                          />
                          <path
                            fill="#034999"
                            d="M148.8729401-347.2924805c-7.4659729,0-13.6568756,3.6025696-16.4877167,8.4835205l9.1573334,4.2090454   c0.8569794-2.2304688,3.5183105-4.6705017,6.4979248-4.6705017c3.3454742,0,4.6530457,1.8330688,4.089447,4.3003845   c-0.3531494,1.4102478-1.4107208,2.2559204-3.0319061,2.2559204l-6.5162506,0.0018921   c-6.2153931,0-12.2862396,2.890625-13.6597443,10.0458374c-1.2986298,6.5675964,3.4561462,12.3413086,10.1621552,12.3577881   c4.6092682-0.0084534,7.9425354-2.0680237,9.4332886-5.0490417l-0.8536987,4.4807129h11.6646881l4.3376007-22.3330078   C165.2312012-341.3181763,158.7591858-347.2924805,148.8729401-347.2924805 M150.2954407-324.1420593   c-0.5688019,3.1340637-3.4839325,5.6546021-6.3279266,5.6546021c-2.8440094,0-4.1954041-1.6348572-3.7683105-3.6788635   c0.4266052-2.0440063,2.2036285-2.7931519,4.2655182-2.7931519h5.9729004L150.2954407-324.1420593z"
                          />
                          <path
                            fill="#034999"
                            d="M217.2517242-323.181488h9.8862152c-0.2133026,2.5605469,2.2050476,4.2674255,5.2632904,4.2674255   c2.6316833,0,4.6940308-1.138092,4.6940308-2.9160461c0-4.9073486-16.7141876,0.2843933-16.7141876-12.9444885   c0-7.1123962,8.1793365-12.5178833,16.0027161-12.5178833c8.6059875,0,14.3674316,4.9784241,13.5137634,12.0196838h-9.9573059   c0.0710907-2.4178772-2.2050781-4.1247559-4.6234283-4.1247559c-2.4889832,0-4.2669525,1.138092-4.2669525,3.20047   c0,5.0499878,17.2114563-0.7825623,17.2114563,12.3756714c0,8.0366821-7.1830139,13.5133057-16.855957,13.5133057   C222.4434204-310.3081055,216.3269196-315.9269104,217.2517242-323.181488"
                          />
                          <path
                            fill="#034999"
                            d="M208.7178192-337.0505676h9.03302l1.8547363-9.7044983h-9.0325775l1.8895721-9.6503296h-11.7353058   l-6.3053131,32.5126038c-1.6362305,8.1082764,3.2715607,13.0155945,11.3082428,13.0155945h6.8995514l1.9201813-9.6729431h-5.120636   c-2.2761688,0-3.6275482-1.4224548-3.129837-3.911438L208.7178192-337.0505676z"
                          />
                          <polygon
                            fill="#F47920"
                            points="257.3513794,-317.1156921 256.1384277,-310.8781738 249.5976715,-310.8781738    250.8106079,-317.1156921  "
                          />
                          <path
                            fill="#F47920"
                            d="M260.5550537-323.5925598c1.4559021-7.3737183,7.8596191-12.128479,15.379303-12.128479   c6.84021,0,11.1575623,4.1723022,10.3820496,9.9455566h-8.1506042c-0.0485229-1.8439026-1.5039673-3.1533813-4.0263672-3.1533813   c-2.3769226,0-4.8512878,1.7949524-5.5307617,5.3363037c-0.6794739,3.6873169,1.1644287,6.3071899,4.1723022,6.3071899   c2.1829224,0,3.6868591-1.358429,4.4147949-3.2023315h8.3441772c-1.2614136,5.8707275-7.6651611,9.9940796-13.5834351,9.9940796   C263.951355-310.4936218,259.1000671-316.2183838,260.5550537-323.5925598"
                          />
                          <path
                            fill="#F47920"
                            d="M288.449646-320.9728699c-0.3399963-8.3926697,6.3062439-14.7478943,14.7958984-14.7478943   c6.6471863,0,11.4980164,4.6087952,11.6924438,10.4790649c0.3395081,8.3931274-6.3067322,14.7478638-14.7968445,14.7478638   C293.4944458-310.4938354,288.6436462-315.1021423,288.449646-320.9728699 M306.8843994-324.2717285   c0-2.8623657-1.697937-4.6573181-4.3658752-4.6573181c-3.7358398,0-6.0162048,3.4448547-6.0162048,6.9862061   c0,2.8623657,1.6984253,4.6572876,4.3667908,4.6572876C304.6044617-317.285553,306.8843994-320.7303772,306.8843994-324.2717285"
                          />
                          <path
                            fill="#F47920"
                            d="M320.7086487-335.3296509h8.0046692l-0.581543,2.9108582   c1.8434448-1.9404297,4.3178406-3.2988586,7.4222107-3.2988586c3.7358398,0,5.6272888,1.4554443,6.4042053,4.1238098   c1.7464294-2.1348877,5.0937805-4.1238098,8.6356506-4.1238098c5.8212585,0,8.538147,4.0753174,7.4706726,9.5575562   l-2.9593506,15.2818604h-8.0046692l2.6683655-13.6809082c0.5339661-2.7168884-0.6309509-4.4633179-2.9108582-4.4633179   c-2.2803955,0-4.1238098,1.7464294-4.6568298,4.4633179l-2.668396,13.6809082h-8.005127l2.668396-13.6809082   c0.5329895-2.7168884-0.6309814-4.4633179-2.9108887-4.4633179c-2.2803955,0-4.1242981,1.7464294-4.6577759,4.4633179   l-2.668396,13.6809082h-8.0046692L320.7086487-335.3296509z"
                          />
                        </g>
                        <g>
                          <g>
                            <path
                              fill="#F47920"
                              d="M269.8984375,25.1027527v-0.5922852h3.5283203v0.5922852h-1.421875v3.9677734h-0.6865234v-3.9677734    H269.8984375z"
                            />
                            <path
                              fill="#F47920"
                              d="M274.2041016,24.5104675h0.8349609l1.4511719,3.5449219h0.0537109l1.4521484-3.5449219h0.8349609    v4.5600586h-0.6552734v-3.2998047h-0.0419922l-1.3447266,3.2929688h-0.5429688l-1.3447266-3.2949219h-0.0429688v3.3017578    h-0.6542969V24.5104675z"
                            />
                          </g>
                        </g>
                      </svg>
                    </td>
                  </tr>
                  <tr>
                    <td
                      valign="top"
                      width="50%"
                      style={{
                        fontFamily: "Arial, Helvetica, sansSerif",
                        fontSize: "10px",
                        color: "#666666",
                      }}
                    >
                      <span>
                        1301 Ave T, <br />
                        Grand Prairie, TX, 75050 <br />
                      </span>
                      <br />
                      <span>Tel. No. 1-866-529-0412</span>
                    </td>
                    <td
                      style={{
                        fontFamily: "Arial, Helvetica, sansSerif",
                        fontSize: "14px",
                        color: "#394fa1",
                        paddingBottom: "50px",
                        textAlign: "right",
                      }}
                    />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td />
          </tr>
          <tr>
            <td valign="top">
              <table cellPadding="0" cellSpacing="0" width="100%">
                <tbody>
                  <tr id="bgColor">
                    <td
                      vlign="top"
                      style={{
                        fontFamily: "Arial, Helvetica, sansSerif",
                        fontSize: "16px",
                        border: "1px solid #000",
                        textAlign: "left",
                        padding: "10px 20px",
                        backgroundColor: "#d8d8d8",
                        color: "#000",
                      }}
                    >
                      <table cellPadding="0" cellSpacing="0" width="100%">
                        <tbody>
                          <tr>
                            <td width="25%" vlign="top">
                              Shipping Address
                            </td>
                            <td width="25%" vlign="top">
                              Shipping Method
                            </td>
                            <td width="25%" vlign="top">
                              &nbsp;
                            </td>
                            <td width="25%" vlign="top">
                              &nbsp;
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr style={{ marginBottom: "30px" }}>
                    <td vlign="top">
                      <table cellPadding="0" cellSpacing="0" width="100%">
                        <tbody>
                          <tr>
                            <td
                              vlign="top"
                              style={{
                                fontFamily: "Arial, Helvetica, sansSerif",
                                fontSize: "14px",
                                border: "1px solid #000",
                                borderTop: "0px solid #000",
                                textAlign: "left",
                                padding: "10px 20px",
                                color: "#000",
                              }}
                            >
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                width="100%"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      width="25%"
                                      style={{ verticalAlign: "top" }}
                                    >
                                      <span style={{ lineHeight: "22px" }}>
                                        <b>{shippingInfo.name || ""}</b>
                                      </span>
                                      <br />
                                      <span style={{ lineHeight: "22px" }}>
                                        {shippingInfo.streetAddress || ""}
                                      </span>
                                      <br />
                                      <span style={{ lineHeight: "22px" }}>
                                        {shippingInfo.suburbAddress || ""}
                                      </span>
                                      <br />
                                      <span style={{ lineHeight: "22px" }}>
                                        {`${shippingInfo.city || ""}, ${
                                          shippingInfo.state || ""
                                        }`}
                                      </span>
                                      <br />
                                      <span style={{ lineHeight: "22px" }}>
                                        {`${shippingInfo.postCode || ""}`}
                                      </span>
                                      <br />
                                      <span style={{ lineHeight: "22px" }}>
                                        {shippingInfo.country || ""}
                                      </span>
                                      <br />
                                      <span style={{ lineHeight: "22px" }}>
                                        {shippingInfo.telephone || ""}
                                      </span>
                                    </td>
                                    <td
                                      width="25%"
                                      style={{ verticalAlign: "top" }}
                                    >
                                      {(shippingMethod?.toLowerCase() ===
                                      "2 day"
                                        ? "TWODAY"
                                        : getShippingMethodLabel(shippingMethod)) || ""}
                                    </td>
                                    <td
                                      width="25%"
                                      style={{ verticalAlign: "top" }}
                                    >
                                      <span style={{ lineHeight: "22px" }}>
                                        Order #:
                                        <br />
                                      </span>
                                      <span style={{ lineHeight: "22px" }}>
                                        Order Placed:
                                        <br />
                                      </span>
                                      <span style={{ lineHeight: "22px" }}>
                                        Order Total:
                                      </span>
                                    </td>
                                    <td
                                      width="25%"
                                      style={{
                                        verticalAlign: "top",
                                        textAlign: "right",
                                      }}
                                    >
                                      <span style={{ lineHeight: "22px" }}>
                                        <b>{merchantId || ""}</b>
                                        <br />
                                      </span>
                                      <span style={{ lineHeight: "22px" }}>
                                        {date || ""}
                                        <br />
                                      </span>
                                      <span style={{ lineHeight: "22px" }}>
                                        {`$${total}`}
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <table cellPadding="0" cellSpacing="0" width="100%">
                        <tbody>
                          <tr>
                            <td
                              vlign="top"
                              style={{
                                fontFamily: "Arial, Helvetica, sansSerif",
                                fontSize: "16px",
                                border: "1px solid #000",
                                textAlign: "left",
                                padding: "10px 20px",
                                background: "#d8d8d8",
                                color: "#000",
                              }}
                            >
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                width="100%"
                              >
                                <tbody>
                                  <tr>
                                    <td width="25%" vlign="top">
                                      Order Details
                                    </td>
                                    <td width="25%" vlign="top">
                                      &nbsp;
                                    </td>
                                    <td width="25%" vlign="top">
                                      &nbsp;
                                    </td>
                                    <td width="25%" vlign="top">
                                      &nbsp;
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>

                          <tr style={{ marginBottom: "30px" }}>
                            <td vlign="top">
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                width="100%"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      vlign="top"
                                      style={{
                                        fontFamily:
                                          "Arial, Helvetica, sansSerif",
                                        fontSize: "14px",
                                        border: "1px solid #000",
                                        borderTop: "0px solid #000",
                                        textAlign: "left",
                                        padding: "10px 20px",
                                        color: "#000",
                                      }}
                                    >
                                      <table
                                        cellPadding="0"
                                        cellSpacing="0"
                                        width="100%"
                                      >
                                        {items.map((product, index) => {
                                          const { parentSku } = product;

                                          const {
                                            title,
                                            hasVehicle,
                                            vehicleInfo,
                                            hasPartOrSkuNumber,
                                            partNumber,
                                            skuNumber,
                                            quantity,
                                            hasTotalUnitPrice,
                                            totalUnitPrice,
                                            regularPrice,
                                            listPrice,
                                            hasTotalCore,
                                            totalCore,
                                            hasQuantity,
                                            corePrice,
                                            hasTotalWarranty,
                                            warrantyLabelValue,
                                            totalWarranty,
                                            hasWarrantyPrice,
                                            warrantyPrice,
                                            hasTotalAmount,
                                            totalAmount,
                                            hasProductProtection,
                                            productProtectionLabel,
                                            productProtectionPrice,
                                            totalProductProtection,
                                          } = getProductValues(
                                            product,
                                            pageType
                                          );
                                          return (
                                            <tbody key={`invoicePrd${index}`}>
                                              <tr>
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                    }}
                                                  >
                                                    {title || ""}
                                                  </span>
                                                  <br />
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                      color: "#666666",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {hasVehicle
                                                      ? `FOR ${vehicleInfo}`
                                                      : ""}
                                                  </span>
                                                </td>

                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </tr>

                                              {hasPartOrSkuNumber ? (
                                                <tr>
                                                  <td
                                                    width="50%"
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        lineHeight: "22px",
                                                        color: "#666666",
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {`Part #: ${
                                                        partNumber ||
                                                        skuNumber ||
                                                        ""
                                                      }`}
                                                    </span>
                                                  </td>
                                                  <td
                                                    width="50%"
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        lineHeight: "22px",
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              ) : null}

                                              <tr>
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                    }}
                                                  >
                                                    {`Qty`}
                                                  </span>
                                                </td>
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                    }}
                                                  >
                                                    {quantity || ""}
                                                  </span>
                                                </td>
                                              </tr>

                                              <tr>
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                    }}
                                                  >
                                                    {`Unit Price`}
                                                  </span>
                                                </td>
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    {hasTotalUnitPrice
                                                      ? `$${totalUnitPrice}`
                                                      : ""}

                                                    {hasQuantity &&
                                                    (listPrice || regularPrice)
                                                      ? ` ($${
                                                          listPrice ||
                                                          regularPrice ||
                                                          0
                                                        } each)`
                                                      : ""}
                                                  </span>
                                                </td>
                                              </tr>

                                              {hasTotalCore ? (
                                                <tr>
                                                  <td
                                                    width="50%"
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        lineHeight: "22px",
                                                      }}
                                                    >
                                                      {`Core charge`}
                                                    </span>
                                                  </td>
                                                  <td
                                                    width="50%"
                                                    style={{
                                                      verticalAlign: "top",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        lineHeight: "22px",
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      {`$${totalCore}`}

                                                      {hasQuantity && corePrice
                                                        ? ` ($${corePrice} each)`
                                                        : ""}
                                                    </span>
                                                  </td>
                                                </tr>
                                              ) : null}

                                              {hasTotalWarranty ? (
                                                <tr>
                                                  <td
                                                    width="50%"
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        lineHeight: "22px",
                                                      }}
                                                    >
                                                      {warrantyLabelValue || ""}
                                                    </span>
                                                  </td>
                                                  <td
                                                    width="50%"
                                                    style={{
                                                      verticalAlign: "top",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        lineHeight: "22px",
                                                      }}
                                                    >
                                                      {`$${totalWarranty}`}

                                                      {hasQuantity &&
                                                      hasWarrantyPrice
                                                        ? ` ($${warrantyPrice} each)`
                                                        : ""}
                                                    </span>
                                                  </td>
                                                </tr>
                                              ) : null}
                                              {hasProductProtection ? (
                                                <tr>
                                                  <td
                                                    width="50%"
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        lineHeight: "22px",
                                                      }}
                                                    >
                                                      {productProtectionLabel ||
                                                        ""}
                                                    </span>
                                                  </td>
                                                  <td
                                                    width="50%"
                                                    style={{
                                                      verticalAlign: "top",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        lineHeight: "22px",
                                                      }}
                                                    >
                                                      {`$${totalProductProtection}`}

                                                      {hasQuantity &&
                                                      productProtectionPrice
                                                        ? ` ($${productProtectionPrice} each)`
                                                        : ""}
                                                    </span>
                                                  </td>
                                                </tr>
                                              ) : null}
                                              <tr
                                                style={{
                                                  marginBottom: "30px",
                                                }}
                                              >
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                    }}
                                                  >
                                                    Item Total
                                                    <br />
                                                  </span>
                                                </td>
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                    }}
                                                  >
                                                    <b>
                                                      {hasTotalAmount
                                                        ? `$${totalAmount}`
                                                        : ""}
                                                    </b>
                                                  </span>
                                                </td>
                                              </tr>

                                              {parentSku && (
                                                <tr
                                                  style={{
                                                    color: "#a4a4a4",
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  <td
                                                    style={{
                                                      padding: "6pt 0",
                                                    }}
                                                  >
                                                    <b>Included in:</b>
                                                    <br />
                                                    {parentSku.sku_title} <br />
                                                    Part no.:
                                                    {` ${parentSku.sku}`} <br />
                                                    Item Total:
                                                    {` $${parentSku.list_price}`}
                                                    {parentSku.cpp
                                                      ? " (with Protection Plan)"
                                                      : ""}
                                                  </td>
                                                </tr>
                                              )}

                                              <tr
                                                style={{
                                                  marginBottom: "30px",
                                                }}
                                              >
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                    }}
                                                  >
                                                    <br />
                                                  </span>
                                                </td>
                                                <td
                                                  width="50%"
                                                  style={{
                                                    verticalAlign: "top",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      lineHeight: "22px",
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          );
                                        })}
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <td>&nbsp;</td>
                          </tr>

                          <tr>
                            <td valign="top">
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                width="100%"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      vlign="top"
                                      style={{
                                        fontFamily:
                                          "Arial, Helvetica, sansSerif",
                                        fontSize: "16px",
                                        border: "1px solid #000",
                                        textAlign: "left",
                                        padding: "10px 20px",
                                        background: "#d8d8d8",
                                        color: "#000",
                                      }}
                                    >
                                      <table
                                        cellPadding="0"
                                        cellSpacing="0"
                                        width="100%"
                                      >
                                        <tbody>
                                          <tr>
                                            <td width="33%" vlign="top">
                                              Billing Address
                                            </td>
                                            <td width="33.33%" vlign="top">
                                              Payment Method
                                            </td>
                                            <td width="33.33%" vlign="top">
                                              Order Summary
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>

                                  <tr style={{ marginBottom: "30px" }}>
                                    <td vlign="top">
                                      <table
                                        cellPadding="0"
                                        cellSpacing="0"
                                        width="100%"
                                      >
                                        <tbody>
                                          <tr>
                                            <td
                                              vlign="top"
                                              style={{
                                                fontFamily:
                                                  "Arial, Helvetica, sansSerif",
                                                fontSize: "14px",
                                                border: "1px solid #000",
                                                borderTop: "0px solid #000",
                                                textAlign: "left",
                                                padding: "10px 20px",
                                                color: "#000",
                                              }}
                                            >
                                              <table
                                                cellPadding="0"
                                                cellSpacing="0"
                                                width="100%"
                                              >
                                                <tbody>
                                                  <tr>
                                                    <td
                                                      width="33.33%"
                                                      style={{
                                                        verticalAlign: "top",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          lineHeight: "22px",
                                                        }}
                                                      >
                                                        <b>
                                                          {billingInfo.name ||
                                                            ""}
                                                        </b>
                                                      </span>
                                                      <br />
                                                      <span
                                                        style={{
                                                          lineHeight: "22px",
                                                        }}
                                                      >
                                                        {billingInfo.streetAddress ||
                                                          ""}
                                                      </span>
                                                      <br />
                                                      <span
                                                        style={{
                                                          lineHeight: "22px",
                                                        }}
                                                      >
                                                        {billingInfo.suburbAddress ||
                                                          ""}
                                                      </span>
                                                      <br />
                                                      <span
                                                        style={{
                                                          lineHeight: "22px",
                                                        }}
                                                      >
                                                        {`${
                                                          billingInfo.city || ""
                                                        }, ${
                                                          billingInfo.state ||
                                                          ""
                                                        } `}
                                                      </span>
                                                      <br />
                                                      <span
                                                        style={{
                                                          lineHeight: "22px",
                                                        }}
                                                      >
                                                        {`${
                                                          billingInfo.postCode ||
                                                          ""
                                                        }`}
                                                      </span>
                                                      <br />
                                                      <span
                                                        style={{
                                                          lineHeight: "22px",
                                                        }}
                                                      >
                                                        {billingInfo.country ||
                                                          ""}
                                                      </span>
                                                      <br />
                                                      <span
                                                        style={{
                                                          lineHeight: "22px",
                                                        }}
                                                      >
                                                        {billingInfo.telephone ||
                                                          ""}
                                                      </span>
                                                    </td>
                                                    <td
                                                      width="33.33%"
                                                      style={{
                                                        verticalAlign: "top",
                                                      }}
                                                    >
                                                      {paymentMethod ===
                                                      "Braintree"
                                                        ? "CreditCard"
                                                        : paymentMethod}
                                                    </td>
                                                    <td
                                                      width="33.33%"
                                                      style={{
                                                        verticalAlign: "top",
                                                      }}
                                                    >
                                                      <table
                                                        cellPadding="0"
                                                        cellSpacing="0"
                                                        width="100%"
                                                      >
                                                        <tbody>
                                                          <tr>
                                                            <td vlign="top">
                                                              Item(s) Subtotal:
                                                            </td>
                                                            <td
                                                              style={{
                                                                verticalAlign:
                                                                  "top",
                                                                textAlign:
                                                                  "right",
                                                                lineHeight:
                                                                  "22px",
                                                              }}
                                                            >
                                                              {`$${subtotal}`}
                                                            </td>
                                                          </tr>
                                                          {shippingProtectionAmount >
                                                            0 && (
                                                            <tr>
                                                              <td vlign="top">
                                                                Shipping
                                                                Protection:
                                                              </td>
                                                              <td
                                                                style={{
                                                                  verticalAlign:
                                                                    "top",
                                                                  textAlign:
                                                                    "right",
                                                                  lineHeight:
                                                                    "22px",
                                                                }}
                                                              >
                                                                {`$${shippingProtectionAmount}`}
                                                              </td>
                                                            </tr>
                                                          )}
                                                          {totalProductProtection >
                                                            0 && (
                                                            <tr>
                                                              <td vlign="top">
                                                                Product
                                                                Protection:
                                                              </td>
                                                              <td
                                                                style={{
                                                                  verticalAlign:
                                                                    "top",
                                                                  textAlign:
                                                                    "right",
                                                                  lineHeight:
                                                                    "22px",
                                                                }}
                                                              >
                                                                {`$${totalProductProtection}`}
                                                              </td>
                                                            </tr>
                                                          )}
                                                          {totalWarranty > 0 &&
                                                            totalProductProtection <=
                                                              0 && (
                                                              <tr>
                                                                <td vlign="top">
                                                                  Part
                                                                  Protection:
                                                                </td>
                                                                <td
                                                                  style={{
                                                                    verticalAlign:
                                                                      "top",
                                                                    textAlign:
                                                                      "right",
                                                                    lineHeight:
                                                                      "22px",
                                                                  }}
                                                                >
                                                                  {`$${totalWarranty}`}
                                                                </td>
                                                              </tr>
                                                            )}
                                                          {totalCorePrice >
                                                            0 && (
                                                            <tr>
                                                              <td vlign="top">
                                                                Core Charge:
                                                              </td>
                                                              <td
                                                                style={{
                                                                  verticalAlign:
                                                                    "top",
                                                                  textAlign:
                                                                    "right",
                                                                  lineHeight:
                                                                    "22px",
                                                                }}
                                                              >
                                                                {`$${totalCorePrice}`}
                                                              </td>
                                                            </tr>
                                                          )}
                                                          <tr>
                                                            <td vlign="top">
                                                              Shipping:
                                                            </td>
                                                            <td
                                                              style={{
                                                                verticalAlign:
                                                                  "top",
                                                                textAlign:
                                                                  "right",
                                                                lineHeight:
                                                                  "22px",
                                                              }}
                                                            >
                                                              {`$${totalShipping}`}
                                                            </td>
                                                          </tr>
                                                          <tr>
                                                            <td vlign="top">
                                                              Handling:
                                                            </td>
                                                            <td
                                                              style={{
                                                                verticalAlign:
                                                                  "top",
                                                                textAlign:
                                                                  "right",
                                                                lineHeight:
                                                                  "22px",
                                                              }}
                                                            >
                                                              {`$${totalHandling}`}
                                                            </td>
                                                          </tr>
                                                          <tr>
                                                            <td
                                                              vlign="top"
                                                              style={{
                                                                paddingBottom:
                                                                  "16px",
                                                              }}
                                                            >
                                                              Tax:
                                                            </td>
                                                            <td
                                                              style={{
                                                                verticalAlign:
                                                                  "top",
                                                                textAlign:
                                                                  "right",
                                                                lineHeight:
                                                                  "22px",
                                                                paddingBottom:
                                                                  "16px",
                                                              }}
                                                            >
                                                              {`$${totalTax}`}
                                                            </td>
                                                          </tr>
                                                          <tr>
                                                            <td
                                                              vlign="top"
                                                              style={{
                                                                fontSize:
                                                                  "16px",
                                                                paddingTop:
                                                                  "16px",
                                                                borderTop:
                                                                  "1px solid #cccccc",
                                                              }}
                                                            >
                                                              <b>Total</b>
                                                            </td>
                                                            <td
                                                              style={{
                                                                fontSize:
                                                                  "16px",
                                                                verticalAlign:
                                                                  "top",
                                                                textAlign:
                                                                  "right",
                                                                lineHeight:
                                                                  "22px",
                                                                paddingTop:
                                                                  "16px",
                                                                borderTop:
                                                                  "1px solid #cccccc",
                                                              }}
                                                            >
                                                              {`$${total}`}
                                                            </td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
